<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>
<style>
html,
body{
  /* height: 100%; */
      width: 100%;
}
#app{
  /* height: 100%; */
      width: 98%;
    overflow: hidden;
    padding: 1%;
}
.pagination-container{
  margin-top: 20px;
  text-align: right;
}
</style>